import moment from 'moment'

import { OnSchedUtils } from ".";

import { AvailableTimes } from "./availabilityUtils";
import { Internationalize } from "./languages";

import StripePaymentForm from "../components/Form/StripePaymentForm/StripePaymentForm"
import AvailabilityForm from "../components/Form/AvailabilityForm/AvailabilityForm";
import BlocksForm from "../components/Form/BlocksForm/BlocksForm";
import FormLoadedDropdown from '../components/Form/FormElement/FormLoadedDropdown/FormLoadedDropdown';
import StateCountry from '../components/Form/StateCountry/StateCountry';


export const Forms = (element, onschedState) => ({
  BookingForm: {
    firstname: {
      component: 'input',
      type: 'text',
      placeholder: Internationalize(element, 'consumer_availability_booking_form_firstName'),
      label: Internationalize(element, 'consumer_availability_booking_form_firstName'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'firstname', 'string', onschedState, 'appointment')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'firstname', 'string', onschedState, 'appointment')?.display,
      required: true,
    },
    lastname: {
      component: 'input',
      type: 'text',
      placeholder: Internationalize(element, 'consumer_availability_booking_form_lastName'),
      label: Internationalize(element, 'consumer_availability_booking_form_lastName'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'lastname', 'string', onschedState, 'appointment')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'lastname', 'string', onschedState, 'appointment')?.display,
      required: true,
    },
    email: {
      component: 'input',
      type: 'text',
      placeholder: Internationalize(element, 'consumer_availability_booking_form_email'),
      label: Internationalize(element, 'consumer_availability_booking_form_email'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'email', 'string', onschedState, 'appointment')?.defaultValue.includes('@') ? OnSchedUtils.InitializeFields(element, 'email', 'string', onschedState, 'appointment')?.defaultValue : '',
      display: OnSchedUtils.InitializeFields(element, 'email', 'string', onschedState, 'appointment')?.display,
      required: true,
      title: "Must be a valid email address"
    },
    phone: {
      component: 'input',
      type: 'tel',
      placeholder: Internationalize(element, 'consumer_availability_booking_form_phone'),
      label: Internationalize(element, 'consumer_availability_booking_form_phone'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'phone', 'string', onschedState, 'appointment')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'phone', 'string', onschedState, 'appointment')?.display,
      title: "Must be a valid phone number"
    },
    customerMessage: {
      component: 'textarea',
      type: 'textarea',
      placeholder: Internationalize(element, 'consumer_availability_booking_form_customerMessage'),
      label: Internationalize(element, 'consumer_availability_booking_form_customerMessage'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'customerMessage', 'string', onschedState, 'appointment')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'customerMessage', 'string', onschedState, 'appointment')?.display,
    },
    stripePaymentForm: {
      component: () => StripePaymentForm(element, onschedState),
      name: 'stripe-payment-form',
      display: element.options.payments?.payments ? "true" : "false",
      fullcolumn: "true"
    },
    customerSMS: {
      component: 'input',
      display: element.options.customerSMS ? "true" : "false",
      name: 'customerSMS',
      type: 'checkbox',
      placeholder: OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_sms'),
      label: OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_sms'),
    },
  },
  ResourceForm: {
    name: {
      component: 'input',
      name: 'name',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_name'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_name'),
      required: true,
      section: 1,
      defaultValue: OnSchedUtils.InitializeFields(element, 'name', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'name', 'string')?.display,
    },
    timezoneName: {
      component: FormLoadedDropdown,
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_timezone'),
      name: 'timezoneName',
      childKey: '/companies/timezones/' + moment().format('YYYY-MM-DD'),
      responseKey: 'timezones',
      required: true,
      onschedState: onschedState,
      element: element,
      display: OnSchedUtils.InitializeFields(element, 'timezoneName', 'select')?.display,
    },
    addressLine1: {
      component: 'input',
      name: 'addressLine1',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_addressLine1'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_addressLine1'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'addressLine1', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'addressLine1', 'string')?.display,
    },
    addressLine2: {
      component: 'input',
      name: 'addressLine2',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_addressLine2'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_addressLine2'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'addressLine2', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'addressLine2', 'string')?.display,
    },
    email: {
      component: 'input',
      name: 'email',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_email'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_email'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'email', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'email', 'string')?.display,
    },
    city: {
      component: 'input',
      name: 'city',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_city'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_city'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'city', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'city', 'string')?.display,
    },
    stateCountry: {
      component: StateCountry,
      onschedState: onschedState,
      element: element,
      fullcolumn: "true"
    },
    postalCode: {
      component: 'input',
      name: 'postalCode',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_postalCode'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_postalCode'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'postalCode', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'postalCode', 'string')?.display,
    },
    conferenceInfo: {
      component: 'input',
      name: 'conferenceInfo',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_conferenceInfo'),
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_conferenceInfo'),
      defaultValue: OnSchedUtils.InitializeFields(element, 'conferenceInfo', 'string')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'conferenceInfo', 'string')?.display,
    },
    groupId: {
      component: FormLoadedDropdown,
      label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_groupId'),
      name: 'groupId',
      childKey: 'resourcegroups',
      responseKey: 'data',
      element: element,
      onschedState: onschedState,
      placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_groupId'),
      required: true,
      defaultValue: OnSchedUtils.InitializeFields(element, 'groupId', 'select')?.defaultValue,
      display: OnSchedUtils.InitializeFields(element, 'groupId', 'select')?.display,
    },
    availability: {
      component: () => AvailabilityForm(element, onschedState),
      name: 'availability',
      display: OnSchedUtils.InitializeFields(element, 'availability', 'custom')?.display,
    },
    // blocks: {
    //   component: () => BlocksForm(element, onschedState),
    //   display: OnSchedUtils.InitializeFields(element, 'blocks', 'string')?.display,
    //   name: 'blocks',
    // },
  },
  ServiceForm: {
    name: {
      component: 'input',
      name: 'name',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_name'),
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_name'),
      required: true,
      section: 1
    },
    type: {
      component: 'select',
      name: 'type',
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_type'),
      type: 'select',
      onschedState: onschedState,
      children: [
        { name: 'Appointment', value: 1 },
        { name: 'Event', value: 2 },
      ],
    },
    duration: {
      component: 'select',
      name: 'duration',
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_duration'),
      type: 'select',
      onschedState: onschedState,
      children: OnSchedUtils.Durations(),
      required: true
    },
    feeAmount: {
      component: 'input',
      name: 'feeAmount',
      type: 'number',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_feeAmount'),
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_feeAmount'),
    },
    variableDuration: {
      component: 'input',
      name: 'variableDuration',
      type: 'checkbox',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_variableDuration'),
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_variableDuration'),
    },
    durationMin: {
      component: 'select',
      name: 'durationMin',
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_durationMin'),
      type: 'select',
      onschedState: onschedState,
      children: OnSchedUtils.Durations(),
      halfcolumn: 'true'
    },
    durationMax: {
      component: 'select',
      name: 'durationMax',
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_durationMax'),
      type: 'select',
      onschedState: onschedState,
      children: OnSchedUtils.Durations(),
      halfcolumn: 'true'
    },
    durationInterval: {
      component: 'select',
      name: 'durationInterval',
      label: OnSchedUtils.Internationalize(element, 'setup_serviceSetup_form_durationInterval'),
      type: 'select',
      onschedState: onschedState,
      children: OnSchedUtils.Durations(),
      halfcolumn: 'true'
    },
    availability: {
      component: () => AvailabilityForm(element, onschedState),
      name: 'availability',
    },
    // blocks: {
    //   component: () => BlocksForm(element, onschedState),
    //   name: 'blocks',
    // },
  },
  LocationForm: {
    name: {
      component: 'input',
      name: 'name',
      value: onschedState?.state?.['name'],
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_name'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_name'),
      display: OnSchedUtils.InitializeFields(element, 'name', 'string')?.display,
      required: true,
      section: 1
    },
    email: {
      component: 'input',
      value: onschedState?.state?.['email'],
      name: 'email',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_email'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_email'),
      display: OnSchedUtils.InitializeFields(element, 'email', 'string')?.display,
    },
    timezoneName: {
      component: 'select',
      value: onschedState?.state?.['timezoneName'],
      name: 'timezoneName',
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_timezone'),
      display: OnSchedUtils.InitializeFields(element, 'timezoneName', 'string')?.display,
      onschedState: onschedState,
      type: 'select',
      required: true
    },
    addressLine1: {
      component: 'input',
      value: onschedState?.state?.['addressLine1'],
      name: 'addressLine1',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_addressLine1'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_addressLine1'),
      display: OnSchedUtils.InitializeFields(element, 'addressLine1', 'string')?.display,
    },
    addressLine2: {
      component: 'input',
      value: onschedState?.state?.['addressLine2'],
      name: 'addressLine2',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_addressLine2'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_addressLine2'),
      display: OnSchedUtils.InitializeFields(element, 'addressLine2', 'string')?.display,
    },
    website: {
      component: 'input',
      value: onschedState?.state?.['website'],
      name: 'website',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_website'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_website'),
      display: OnSchedUtils.InitializeFields(element, 'website', 'string')?.display,
    },
    city: {
      component: 'input',
      value: onschedState?.state?.['city'],
      name: 'city',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_city'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_city'),
      display: OnSchedUtils.InitializeFields(element, 'city', 'string')?.display,
      halfcolumn: 'true'
    },
    // country: {
    //   component: FormLoadedDropdown,
    //   element: element,
    //   childKey: 'customers/countries',
    //   interface: 'consumer',
    //   value: onschedState?.state?.['country'],
    //   name: 'country',
    //   type: 'text',
    //   placeholder: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_country'),
    //   label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_country'),
    //   display: OnSchedUtils.InitializeFields(element, 'country', 'string')?.display,
    //   halfcolumn: 'true'
    // },
    // state: {
    //   component: 'input',
    //   value: onschedState?.state?.['state'],
    //   name: 'state',
    //   type: 'text',
    //   placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_state'),
    //   label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_state'),
    //   display: OnSchedUtils.InitializeFields(element, 'state', 'string')?.display,
    //   halfcolumn: 'true'
    // },
    stateCountry: {
      component: StateCountry,
      onschedState: onschedState,
      element: element,
      fullcolumn: "true"
    },
    postalCode: {
      component: 'input',
      value: onschedState?.state?.['postalCode'],
      name: 'postalCode',
      type: 'text',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_postalCode'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_postalCode'),
      display: OnSchedUtils.InitializeFields(element, 'postalCode', 'string')?.display,
    },
    bookInAdvance: {
      component: 'input',
      value: onschedState?.state?.['bookInAdvance'],
      name: 'bookInAdvance',
      type: 'number',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_bookInAdvance'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_bookInAdvance'),
      display: OnSchedUtils.InitializeFields(element, 'bookInAdvance', 'string')?.display,
    },
    bookAheadValue: {
      component: 'input',
      value: onschedState?.state?.['bookAheadValue'],
      name: 'bookAheadValue',
      type: 'number',
      placeholder: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_bookAheadValue'),
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_bookAheadValue'),
      display: OnSchedUtils.InitializeFields(element, 'bookAheadValue', 'string')?.display,
      halfcolumn: 'true',
    },
    bookAheadUnit: {
      component: 'select',
      value: onschedState?.state?.['bookAheadUnit'],
      name: 'bookAheadUnit',
      label: OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_bookAheadUnit'),
      display: OnSchedUtils.InitializeFields(element, 'bookAheadUnit', 'string')?.display,
      type: 'select',
      onschedState: onschedState,
      children: [
        { name: 'Days', value: 'D' },
        { name: 'Weeks', value: 'W' },
        { name: 'Months', value: 'M' },
      ],
    },
    availability: {
      component: () => AvailabilityForm(element, onschedState),
      display: OnSchedUtils.InitializeFields(element, 'availability', 'string')?.display,
      name: 'availability',
    },
    // blocks: {
    //   component: () => BlocksForm(element, onschedState),
    //   display: OnSchedUtils.InitializeFields(element, 'blocks', 'string')?.display,
    //   name: 'blocks',
    // },
  },
  NewBlockForm: {
    startDate: {
      component: 'input',
      type: 'date',
      name: 'startDate',
      defaultValue: moment().format('YYYY-MM-DD'),
      label: 'start',
      required: true,
    },
    endDate: {
      component: 'input',
      type: 'date',
      defaultValue: moment().format('YYYY-MM-DD'),
      name: 'endDate',
      label: 'end',
      required: true,
    },
    startTime: {
      component: 'select',
      name: 'startTime',
      label: 'from',
      children: Object.values(AvailableTimes(true)),
      required: true,
      defaultValue: (parseInt(moment().format('HH')) + 2) > 24 ? 2300 : (parseInt(moment().format('HH')) + 1) * 100,
    },
    endTime: {
      component: 'select',
      name: 'endTime',
      label: 'to',
      children: Object.values(AvailableTimes(true)),
      required: true,
      defaultValue: (parseInt(moment().format('HH')) + 2) > 24 ? 2400 : (parseInt(moment().format('HH')) + 2) * 100,
    },
    // reason: {
    //   component: 'input',
    //   name: 'reason',
    //   type: 'text',
    //   placeholder: 'Reason',
    //   label: 'Reason',
    //   defaultValue: '',
    // },
    // repeats: true,
    // repeat: {
    //   frequency: "string",
    //   interval: 0,
    //   weekdays: "string",
    //   monthDay: 0,
    //   monthType: "string"
    // }
  }
})

// "name": "string",
// "adminEmail": "string",
// "adminName": "string",
// "timezoneName": "string",
// "friendlyId": "string",
// "phone": "string",
// "fax": "string",
// "website": "string",
// "email": "string",
// "regionId": "string",
// "address": {
//   "addressLine1": "string",
//   "addressLine2": "string",
//   "city": "string",
//   "state": "string",
//   "country": "string",
//   "postalCode": "string"
// },
// "businessHours": {
//   "mon": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "tue": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "wed": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "thu": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "fri": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "sat": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   },
//   "sun": {
//     "startTime": 0,
//     "endTime": 0,
//     "isOpen": true,
//     "is24Hours": true
//   }
// },
// "settings": {
//   "bookAheadUnit": 0,
//   "bookAheadValue": 0,
//   "bookInAdvance": 0,
//   "customerBookingsPerDay": 0,
//   "enableWorldTimezones": true,
//   "bookingTimerMins": 0
// },
// "defaults": {
//   "enableUtcTimezone": true,
//   "customerState": true,
//   "customerCity": true,
//   "autoUpdateCustomer": true,
//   "businessNotification": true,
//   "emailInfo": true
// },
// "appointmentReminders": {
//   "emailFirstReminder": 0,
//   "emailFirstReminderInterval": 0,
//   "emailSecondReminder": 0,
//   "emailSecondReminderInterval": 0,
//   "smsFirstReminder": 0,
//   "smsFirstReminderInterval": 0,
//   "smsSecondReminder": 0,
//   "smsSecondReminderInterval": 0
// }
